import {RequestResult} from "../../common/api/requestResult";
import {UserSessionData} from "../../app/userSessionData";

const authProvider = {
    isAuthenticated: false,
    externalUserLogin(userInfo:any): RequestResult {
        if (userInfo.user.role !== 'admin' && userInfo.user.role !== 'manager') {
            return new RequestResult(false, 'This user does not have access to the admin panel');
        }
        UserSessionData.getInstance().setData(userInfo)
        authProvider.isAuthenticated = true;
        return new RequestResult(true, userInfo.user);
    },
    signout(callback: VoidFunction) {
        authProvider.isAuthenticated = false;
        callback();
    }
};

export {authProvider};